"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplifyingTransformersModule = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../ServiceIdentifiers");
const NodeTransformer_1 = require("../../../enums/node-transformers/NodeTransformer");
const BlockStatementSimplifyTransformer_1 = require("../../../node-transformers/simplifying-transformers/BlockStatementSimplifyTransformer");
const ExpressionStatementsMergeTransformer_1 = require("../../../node-transformers/simplifying-transformers/ExpressionStatementsMergeTransformer");
const IfStatementSimplifyTransformer_1 = require("../../../node-transformers/simplifying-transformers/IfStatementSimplifyTransformer");
const VariableDeclarationsMergeTransformer_1 = require("../../../node-transformers/simplifying-transformers/VariableDeclarationsMergeTransformer");
exports.simplifyingTransformersModule = new inversify_1.ContainerModule((options) => {
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(BlockStatementSimplifyTransformer_1.BlockStatementSimplifyTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.BlockStatementSimplifyTransformer);
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(ExpressionStatementsMergeTransformer_1.ExpressionStatementsMergeTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.ExpressionStatementsMergeTransformer);
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(IfStatementSimplifyTransformer_1.IfStatementSimplifyTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.IfStatementSimplifyTransformer);
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(VariableDeclarationsMergeTransformer_1.VariableDeclarationsMergeTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.VariableDeclarationsMergeTransformer);
});
